import SectionHeading from '@/pages/home/components/SectionHeading';
import { accessSteps } from '@/mocks/home';

export default function AccessSteps() {
  return (
    <section id="access" className="w-full bg-background-100 py-16 md:py-24">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <SectionHeading
          eyebrow="访问指南"
          title="从首页入口进入的五个步骤"
          desc="按顺序操作可以让访问过程更稳妥：先确认环境，再从记录在册的入口进入，最后留意是否出现异常，减少误入陌生页面的可能。"
        />

        <div className="mt-10 md:mt-14 grid grid-cols-1 lg:grid-cols-5 gap-5">
          {accessSteps.map((s, idx) => (
            <div
              key={s.step}
              className={`rounded-lg p-6 border h-full flex flex-col ${
                idx === 0 ? 'bg-primary-50 border-primary-200' : 'bg-background-50 border-background-200/70'
              }`}
            >
              <div className="flex items-center justify-between">
                <span className="font-heading text-2xl md:text-3xl font-bold text-primary-500">{s.step}</span>
                {idx === 0 && (
                  <span className="px-2 py-0.5 rounded-full bg-accent-100 text-accent-800 text-xs font-medium whitespace-nowrap">
                    从这里开始
                  </span>
                )}
              </div>
              <h3 className="mt-4 text-base font-semibold text-foreground-950">{s.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600 flex-1">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}